<template>
  <div v-if="produto" id="produto_info">
    <div>
      <div class="informacoes">
        <div class="images" v-if="produto.url">
          <img :src="produto.url" class="images" />
        </div>
        <div v-else>
          <img src="../assets/image_indisponivel.gif" class="noimages" />
        </div>

        <div class="informacoes_payment" v-if="produto.quantidade >= 1">
          <div id="top_info">
            <h1>{{ produto.nome }}</h1>
            <!-- <p>Código {{ produto.codigoDeBarras }}</p> -->
          </div>
          <p class="old">
            <!-- De -->R$
            {{ produto.preco.preco_venda.toFixed(2).replace(".", ",") }}
          </p>
          <p class="price">
            <!-- por -->
            <b>
              R$
              <span id="valor">
                {{ produto.a_vista.toFixed(2).replace(".", ",") }}
              </span>
              (à vista)
            </b>
          </p>
          <p v-if="produto.qntParcelas !== 1">
            ou R$
            {{ produto.preco.preco_venda.toFixed(2).replace(".", ",") }} em
            {{ produto.qntParcelas }}x de R$
            {{ produto.valor_parcelas.toFixed(2).replace(".", ",") }} sem juros
          </p>

          <p>Selecione o tamanho:</p>
          <button
            id="escolhido"
            type="button"
            @click="selecionarTam(produto.tamanho)"
            v-if="tamanhoSelecionado === produto.tamanho"
          >
            {{ produto.tamanho }}
          </button>
          <button
            v-else
            id="no_escolhido"
            type="button"
            @click="selecionarTam(produto.tamanho)"
          >
            {{ produto.tamanho }}
          </button>
          <p id="error_message" v-if="error_select">Selecione o tamanho</p>

          <div v-if="produto.quantidade == 1">
            <p style="color: red">Resta apenas 1 em estoque!</p>
          </div>

          <div v-if="produto.quantidade > 0">
            <p style="color: red">Disponível em loja física!</p>
          </div>

          <div
            id="qntselect"
            v-if="
              qntSelecionado <= produto.quantidade && produto.quantidade > 1
            "
          >
            <p>Quantidade</p>
            <div id="selectQuantidade" v-if="produto.quantidade > 1">
              <button
                type="button"
                id="quantidadeItems"
                v-if="produto.quantidade > 0"
                @click="diminuir()"
              >
                -
              </button>
              <p id="quantidadeItems">{{ qntSelecionado }}</p>
              <button
                type="button"
                id="quantidadeItems"
                v-if="qntSelecionado <= produto.quantidade"
                @click="aumentar()"
              >
                +
              </button>
            </div>

            <!-- <select v-model="qntSelecionado">
              <option disabled value>Qnt.</option>
              <option v-if="produto.quantidade >= 1">1</option>
              <option v-if="produto.quantidade >= 2">2</option>
              <option v-if="produto.quantidade >= 3">3</option>
              <option v-if="produto.quantidade >= 4">4</option>
            </select> -->
          </div>

          <div id="botaoAddSacola" v-if="produto.url">
            <div v-if="produto.quantidade >= 1">
              <div id="cartadd">
                <button
                  id="addSacola"
                  v-on:click="adicionarASacola"
                  type="button"
                  disabled
                >
                  <!-- <i class="material-icons" id="local_mall">local_mall</i> -->
                  Adicionar à sacola
                </button>
              </div>
            </div>
            <div v-else>
              <div id="cartadd" style="background-color: #e4e4e4">
                <button
                  id="addSacola"
                  type="button"
                  v-on:click="adicionarASacola"
                  disabled
                  style="background-color: #e4e4e4; color: #4e4e4e"
                >
                  <!-- <i
                    class="material-icons"
                    id="local_mall"
                    style="color: #4e4e4e"
                    >close</i
                  > -->
                  Produto indisponível
                </button>
              </div>
            </div>
          </div>
          <p v-if="adicionado" id="adicionado">Produto adicionado!</p>
        </div>
        <div class="informacoes_payment" v-else>
          <div id="top_info">
            <h1>{{ produto.nome }}</h1>
            <!-- <p>Código {{ produto.codigoDeBarras }}</p> -->
          </div>

          <div id="botaoAddSacola">
              <div id="cartadd" style="background-color: #e4e4e4">
                <button
                  id="addSacola"
                  type="button"
                  v-on:click="adicionarASacola"
                  disabled
                  style="background-color: #e4e4e4; color: #4e4e4e"
                >
                  <!-- <i
                    class="material-icons"
                    id="local_mall"
                    style="color: #4e4e4e"
                    >close</i
                  > -->
                  Produto indisponível
                </button>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Recomendacoes recomendacao="Produtos similares" />

      <carousel :perPageCustom="[[768,2], [1024,3]]">
          <slide v-for="(item, i) in subprodutos.slice(0,6)" :key="i">
            <div v-on:click="scrollToTop">
            <Product :product="item"/>
            </div>
          </slide>
        </carousel>

    </div>
  </div>
</template>

<script>
import Recomendacoes from "../components/Recomendacoes";
import Product from "../components/Product";
//import { Carousel, Slide } from 'vue-carousel';
export default {
  components: {
    Recomendacoes,
    Product,
    //Carousel,
    //Slide
  },
  data() {
    return {
      produto: null,
      preco: 0,
      error_select: false,
      tamanhoSelecionado: "",
      qntSelecionado: 1,
      adicionado: false,
      subprodutos: [],
      sacola: [],
    };
  },
  watch: {
    $route() {
      this.getInfo();
    },
  },
  mounted() {
    if (localStorage.getItem("sacola")) {
      try {
        let sacola_ = JSON.parse(localStorage.getItem("sacola"));
        this.sacola = sacola_;
      } catch (e) {
        localStorage.removeItem("sacola");
      }
    }
  },
  beforeMount() {
    this.getInfo();
  },
  methods: {
    aumentar() {
      if (this.qntSelecionado < this.produto.quantidade)
        this.qntSelecionado += 1;
    },
    diminuir() {
      if (this.qntSelecionado > 1) this.qntSelecionado -= 1;
    },
    getInfo() {
      let nomeScreen = this.$route.params.codigo_produto;
      this.$http
        .get(`/opens/produto/${nomeScreen}`)
        .then((res) => {
          let pro = res.data.produto[0];
          if (pro.image[0] && pro.image[0].key) {
            pro.url = `http://api-store.emporiodasmarcas.com.br/files/product/${pro.image[0].key}`;
            //pro.url = `http://localhost:3000/files/product/${pro.image.key}`;
          }
          let qntParcelas = 1;
          while (pro.preco.preco_venda / qntParcelas > 50) {
            qntParcelas++;
          }
          pro.qntParcelas = qntParcelas;

          if (this.sacola) {
            for (let e of this.sacola) {
              if (e && e.item && e.item._id === pro._id) {
                pro.quantidade -= parseInt(e.qntSelecionado);
              }
            }
          } else {
            this.sacola = [];
          }

          let preco = pro.preco.preco_venda;
          preco = preco - (preco * 10) / 100;
          pro.a_vista = preco;

          pro.valor_parcelas = pro.preco.preco_venda / pro.qntParcelas;

          this.produto = pro;

          console.log(pro);

          this.tamanhoSelecionado = pro.tamanho;

          this.$http
            .post(`/opens/produto/visualizacao/add/${this.produto._id}`)
            .then(() => {})
            .catch(() =>
              console.log("Não foi possível adicionar visualização")
            );

          this.getSimilares();
        })
        .catch(() => {});
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    getSimilares() {
      let sub = this.produto.subcategoria;
      this.$http
        .get(`/opens/subcategorias/produtos/${sub}`)
        .then((res) => {
          let subsprods = res.data;
          subsprods = subsprods.filter((p) => p._id != this.produto._id);
          for (let e of subsprods) {
            if (e.image[0] && e.image[0].key) {
              //e.url = `http://localhost:3000/files/product/${e.image.key}`;

              e.url = `https://api-store.emporiodasmarcas.com.br/files/product/${e.image[0].key}`;

            }
            let qntParcelas = 1;
            while (e.preco.preco_venda / qntParcelas > 50) {
              qntParcelas++;
            }

            e.qntParcelas = qntParcelas;
          }

          this.subprodutos = subsprods;
        })
        .catch(() => {});
    },
    adicionarASacola() {
      if (this.tamanhoSelecionado !== "") {
        try {
          let sacola_ = [];
          sacola_ = this.sacola;

          if (!sacola_) {
            sacola_ = [];
          }

          let contido = false;

          for (let e of sacola_) {
            if (e.item && e.item._id === this.produto._id) {
              contido = true;
            }
          }

          if (contido) {
            for (let e of sacola_) {
              if (e.item && e.item._id === this.produto._id) {
                e.qntSelecionado = parseInt(e.qntSelecionado) + 1;
              }
            }
          } else {
            sacola_.push({
              item: this.produto,
              valor: this.produto.preco.preco_venda,
              qntSelecionado: 1,
            });
          }

          this.getInfo();

          const save_ = JSON.stringify(this.sacola);
          localStorage.setItem("sacola", save_);

          this.adicionado = true;
          this.error_select = false;

          this.$router.push(`/sacola`);
          this.$router.go();
        } catch (err) {
          console.log("Error");
        }
      } else {
        this.error_select = true;
      }
    },
    selecionarTam(tamanho) {
      if (this.tamanhoSelecionado === tamanho) {
        this.tamanhoSelecionado = "";
      } else {
        this.tamanhoSelecionado = tamanho;
      }
    },
  },
};
</script>

<style>
#top_info {
  text-align: left;
  display: inline-block;
}

#escolhido {
  border-bottom: 1px solid #7d816d;
  /* border: 1px solid #8d816b; */
  width: 50px;
  /* background-color: #8d816b; */
  color: #7d816d;
  font-size: 16px;
  font-weight: bold;
  margin-right: 10px;
}

#no_escolhido {
  /* border: 1px solid #8d816b; */
  width: 50px;
  color: #8d816b;
  font-size: 18px;
}

#top_info p {
  color: #8c8c8c;
  line-height: 20px;
  display: block;
  font-size: 16px;
}

#top_info h1 {
  font-size: 28px;
  color: #404040;
  font-weight: 400;
}

#qntselect select {
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border: 1px solid #e4e4e4;
  padding: 10px;
  width: 70px;
}

#produto_info {
  margin-top: 30px;
  padding-left: 10px;
  padding-right: 10px;
  width: 98%;
  overflow: hidden;
}

#produto_info .informacoes .informacoes_payment #top_info h1{
  text-transform: uppercase;
}

#slide_item {
  width: 40px;
}

.informacoes {
  display: inline-flex;
  line-height: 10mm;
  width: 100%;
}

.images {
  width: 60%;
  margin-right: 2%;
}

.images img {
  width: 400px;
}

.noimages {
  width: 40%;
  margin-right: 2%;
}

.informacoes_payment {
  width: 40%;
  text-align: left;
  padding: 20;
  color: #404040;
  background-color: #ffffff;
  min-height: 530px;
}

.old {
  color: #8c8c8c;
  text-decoration: line-through;
  font-size: 16px;
  line-height: 24px;
}

.price {
  color: #404040;
}

#valor {
  font-size: 28px;
  font-weight: bold;
  margin-right: 5px;
  margin-left: 5px;
}

#cartadd {
  border-radius: 10px;
  padding: 1px;
  align-self: center;
  margin-top: 20px;
}

#botaoAddSacola {
}

#selectQuantidade {
  display: inline-flex;
  width: 100px;
  align-self: center;
  flex-direction: row;
}

#quantidadeItems {
  width: 30px;
  align-items: center;
  text-align: center;
  padding: 5px;
}

#addSacola {
  padding: 5px;
  background-color: #67bf47;
  color: #ffffff;
  text-align: center;
  font-weight: 600;
  border-radius: 40px;
  cursor: pointer;
  font-size: 14px;
  padding-right: 20px;
  padding-left: 20px;
}

#addSacola:disabled {
  background-color: #cccccc;
}

#local_mall {
  width: 25px;
  margin-right: 10px;
  color: #ffffff;
  display: inline-flex;
}

#adicionado {
  font-weight: 700;
  color: #404040;
}

@media screen and (max-width: 800px) {
  .informacoes {
    display: inline-block;
    width: 100%;
    line-height: 10mm;
  }

  .informacoes_payment {
    width: 100%;
    text-align: left;
    padding: 20px;
    color: #404040;
    background-color: #ffffff;
    min-height: 530px;
  }

  .images {
    width: auto;
    padding: 0px 2%;
  }

  .images img {
    width: 100%;
  }

  #top_info h1 {
    width: 300px;
  }

  #carousel_infoProd {
    width: auto;
  }
}
</style>
